var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5177 3.53331C11.4081 2.57289 10.6459 1.81066 9.68544 1.70105L8.78615 2.60033C9.59206 2.97536 10.2434 3.62669 10.6184 4.4326L11.5177 3.53331ZM3.08303 8.30346L7.43544 3.95105C8.39586 4.06066 9.15809 4.82289 9.2677 5.78331L4.91529 10.1357C4.8842 10.1668 4.852 10.1966 4.81877 10.225C4.58613 10.4239 4.30304 10.5564 3.99947 10.607L2.33418 10.8846L2.61173 9.21928C2.66955 8.87235 2.83433 8.55216 3.08303 8.30346ZM8.68432 0.315681L6.43432 2.56568L1.88979 7.11021C1.39239 7.60761 1.06283 8.248 0.947191 8.94185L0.54018 11.3839C0.413276 12.1454 1.0734 12.8055 1.83482 12.6786L4.2769 12.2716C4.97075 12.1559 5.61114 11.8264 6.10853 11.329L10.6531 6.78443L12.9031 4.53443C13.1052 4.3323 13.2188 4.05816 13.2188 3.77231C13.2188 1.68892 11.5298 0 9.44644 0C9.16059 0 8.88645 0.113554 8.68432 0.315681ZM0.84375 14.0625C0.37776 14.0625 0 14.4403 0 14.9062C0 15.3722 0.37776 15.75 0.84375 15.75H12.6562C13.1222 15.75 13.5 15.3722 13.5 14.9062C13.5 14.4403 13.1222 14.0625 12.6562 14.0625H0.84375Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ACB2C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenMedium);
export default __webpack_public_path__ + "static/media/penMedium.2eafb3988b33c13a1075fbed5bc5a8d8.svg";
export { ForwardRef as ReactComponent };